import React from 'react';

import './contentTable.scss'

import Select from 'react-select'

const ContentTable = (props) => {
    const subtypes = [
        { value: 'cc', label: 'Cost Center' },
        { value: 'analysis', label: 'Analytics' },
        { value: 'employment', label: 'Employment' }
    ]
    const visibility = [
        { value: 'all', label: 'Everyone' },
        { value: 'assignees', label: 'Role Assignees' },
        { value: 'assignee-member', label: 'Role Assignees and Members' },
        { value: 'assignee-superiors', label: 'Role Assignees of Current and Superiors' },

    ]
    const newD = 'M3 5.505C3 5.226 3.215 5 3.49 5h3.02c.27 0 .49.214.49.505v.99A.495.495 0 0 1 6.51 7H3.49A.49.49 0 0 1 3 6.495zm0 4C3 9.226 3.215 9 3.49 9h3.02c.27 0 .49.214.49.505v.99a.495.495 0 0 1-.49.505H3.49a.49.49 0 0 1-.49-.505zm0 4c0-.279.215-.505.49-.505h3.02c.27 0 .49.214.49.505v.99a.495.495 0 0 1-.49.505H3.49a.49.49 0 0 1-.49-.505zm0 4c0-.279.215-.505.49-.505h3.02c.27 0 .49.214.49.505v.99a.495.495 0 0 1-.49.505H3.49a.49.49 0 0 1-.49-.505zm6-12C9 5.226 9.229 5 9.5 5h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505zm0 4C9 9.226 9.229 9 9.5 9h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505zm0 4c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505zm0 4c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505z'

    const externalUrl = [
        { value: 'yes', label: 'Yes'},
        { value: "no", label: "No"}
    ]
    const companyRestrictions = [
        { value: 'yes', label: 'Yes'},
        { value: "no", label: "No"}
    ]
    const replaceDropdownImg = () => {
        let elements = document.querySelectorAll('[d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"]')
        elements.forEach(element => {
            element.setAttribute('d', newD)
        })
    }
    const reorganization = props.reorganization ? props.reorganization.label : '(empty)'

    return (
        <div className='contentTable'>
            <table>
                <tbody>
                    <tr className='formItem'>
                        <td className='label' id='createCostCenter-reorganization-label'>Reorganization</td>
                        <td className='req'></td>
                        <td className='item' aria-labelledby='createCostCenter-reorganization-label'>{reorganization}</td>
                    </tr>

                    <tr className='formItem'>
                        <td className='label'><label htmlFor='createCostCenter-availabilityDate'>Availability Date</label></td>
                        <td className='req' aria-hidden='true'>*</td>
                        <td className='item'>
                            <input className='input date' type='date' id='createCostCenter-availabilityDate' name='availabilityDate' required aria-required='true'/>
                        </td>
                    </tr>

                    <tr className='formItem'>
                        <td className='label'><label htmlFor='createCostCenter-name'>Name</label></td>
                        <td className='req'></td>
                        <td className='item'>
                            <input className='input' type='text' id='createCostCenter-name' name='name'/>
                        </td>
                    </tr>

                    <tr className='formItem'>
                        <td className='label'><label htmlFor='createCostCenter-code'>Code</label></td>
                        <td className='req'></td>
                        <td className='item'>
                            <input className='input' type='number' id='createCostCenter-code' name='code'/>
                        </td>
                    </tr>

                    <tr className='formItem'>
                        <td className='label'><label htmlFor='createCostCenter-includeCodeInName'>Include Code in Name</label></td>
                        <td className='req'></td>
                        <td className='item'>
                            <input className='input check' type='checkbox' id='createCostCenter-includeCodeInName' name='includeCodeInName'/>
                        </td>
                    </tr>

                    <tr className='formItem'>
                        <td className='label'><label htmlFor='createCostCenter-subtype'>Subtype</label></td>
                        <td className='req' aria-hidden='true'>*</td>
                        <td className='item'>
                            <Select className='select' inputId='createCostCenter-subtype' name='subtype' options={subtypes} maxMenuHeight={180} required aria-required='true'/>
                        </td>
                    </tr>

                    <tr className='formItem'>
                        <td className='label'><label htmlFor='createCostCenter-visibility'>Visibility</label></td>
                        <td className='req' aria-hidden='true'>*</td>
                        <td className='item'>
                            <Select className='select' inputId='createCostCenter-visibility' name='visibility' options={visibility} maxMenuHeight={180} required aria-required='true'/>
                        </td>
                    </tr>

                    <tr className='formItem'>
                        <td className='label'><label htmlFor='createCostCenter-externalUrl'>External URL</label></td>
                        <td className='req'></td>
                        <td className='item'>
                            <Select className='select' inputId='createCostCenter-externalUrl' name='externalUrl' options={externalUrl} maxMenuHeight={180}/>
                        </td>
                    </tr>

                    <tr className='formItem'>
                        <td className='label'><label htmlFor='createCostCenter-restrictedToCompanies'>Restricted to Companies</label></td>
                        <td className='req'></td>
                        <td className='item'>
                            <Select className='select' inputId='createCostCenter-restrictedToCompanies' name='restrictedToCompanies' options={companyRestrictions} maxMenuHeight={180}/>
                        </td>
                    </tr>

                </tbody>
            </table>
            {replaceDropdownImg()}
        </div>
    )
}

export default ContentTable;
